import React, { Component } from "react";
import { Checkbox } from "material-ui";
import map from "lodash/map";

class SubValuePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focusItemId: undefined,
    };
  }
  render() {
    let clsName = "ml-20 mr-10 pb-20";
    return (
      <div
        key={this.props.key + "-value-node-contianer"}
        className="light-grey-border"
        style={{
          height: "520px",
          overflowY: "scroll",
        }}
      >
        <div className="pt-20 ml-20 mr-20 mb-20 pb-10 light-grey-bottom-border">
          <strong>{this.props.title}</strong>
        </div>

        {map(this.props.displayData, data => {
          return (
            <div
              key={data.id + "-sub-attributes-line"}
              style={{ display: "flex", justifyContent: "space-between" }}
              className="pt-20 ml-20 mr-20"
            >
              <div
                key={data.id + "-sub-attributes-name"}
                style={{ width: "250px", flex: "1 1 0" }}
              >
                {data.name}
              </div>
              <div
                key={data.id + "-sub-attr-values-list"}
                style={{ flex: "1 1 0" }}
              >
                {map(data.values, v => {
                  return (
                    <div
                      key={v.label + v.id + "_node"}
                      style={{ color: "#017FB5", cursor: "pointer" }}
                      className={clsName}
                      onClick={() => {
                        this.setState({
                          indexKey: v.id,
                        });
                      }}
                      onMouseOver={() => {
                        this.setState({ focusItemId: v.id });
                      }}
                    >
                      <Checkbox
                        label={
                          this.state.focusItemId === v.id && data.granularity
                            ? [
                                <span key={v.label + "-" + v.id + "-span"}>
                                  {v.label}
                                </span>,
                                <span
                                  key={v.label + "-" + v.id + "-granularity"}
                                  className="ml-10 black-border p-5"
                                >
                                  {data.granularity}
                                </span>,
                              ]
                            : v.label
                        }
                        labelStyle={{
                          fontSize: "16px",
                        }}
                        iconStyle={{ fill: "#A3A3A3", marginRight: "10px" }}
                        checked={
                          this.props.selected_segments.indexOf(v.id) >= 0
                        }
                        onCheck={(e, isInputChecked) => {
                          this.props.onCheck(v.id, isInputChecked);
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default SubValuePanel;



// WEBPACK FOOTER //
// ./src/components/AudienceBuilder/SubValuePanel.js